import { render, staticRenderFns } from "./FarmCreateLink.vue?vue&type=template&id=fffdf69a&scoped=true"
import script from "./FarmCreateLink.vue?vue&type=script&lang=js"
export * from "./FarmCreateLink.vue?vue&type=script&lang=js"
import style0 from "./FarmCreateLink.vue?vue&type=style&index=0&id=fffdf69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffdf69a",
  null
  
)

export default component.exports